export const environment = {
  production: true
};

export const SERVER_URL = 'https://api.megaincentivos.com';
export const API_GATEWAY_URL = 'https://api.megaincentivos.com';
export const SOCKET_URL = 'wss://fphxn18hzh.execute-api.us-west-2.amazonaws.com/production'
export const MEGAPAY_URL = 'https://megapay.megaincentivos.com';